import {
  Box,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { Fragment } from "react";

export const PcAndTemplateProductFilterHeader = ({
  checked,
  setChecked,
  px = "8px",
  isCategory = false,
}) => {
  return (
    <Fragment>
      {isCategory && (
        <Box height="36px" px={px}>
          <FormControlLabel
            control={<Switch value={checked} checked={checked} />}
            label="All Products"
            sx={{
              "& .MuiFormControlLabel-label": {
                fontWeight: 500,
              },
              "& .MuiSwitch-thumb": {
                bgcolor: "neutral.63",
              },
              "& .Mui-checked .MuiSwitch-thumb": {
                bgcolor: "primary.main",
              },
              "& .MuiSwitch-track": {
                bgcolor: "neutral.90",
              },
              color: "primary.main",
            }}
            onChange={(_, value) => setChecked(value)}
          />
        </Box>
      )}
      <Stack
        p={px}
        height="34px"
        justifyContent="space-between"
        alignItems="center"
        display="flex"
        flexDirection="row"
        sx={{ backgroundColor: "neutral.98" }}
      >
        <Typography fontWeight={600} fontSize="12px">
          Recipe Name
        </Typography>
        <Typography fontWeight={600} fontSize="12px">
          Quantity
        </Typography>
      </Stack>
    </Fragment>
  );
};
